import { render, staticRenderFns } from "./AccountStatistics.vue?vue&type=template&id=d489f9d0"
import script from "./AccountStatistics.vue?vue&type=script&lang=js"
export * from "./AccountStatistics.vue?vue&type=script&lang=js"
import style0 from "./AccountStatistics.vue?vue&type=style&index=0&id=d489f9d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports